import React from 'react';
import { BrandCreateQuery } from '../graphql/query/BrandCreateQuery';
import { EntityEditFetcher } from '../components/EntityEditFetcher';
import { toRefInput } from '../utils/dataTrasform';
import { BrandCreateMutation } from '../graphql/mutations/BrandCreateMutation';
import typeIntro from '../static/introspection/Brand.json';
import inputTypeIntro from '../static/introspection/BrandCreateInput.json';
import { editorialSectionsToTree } from '../utils/tree';
import { ENTITY } from '../utils/entities';
import { UserData } from '@food/auth';
import { graphqlQuery } from '../utils/graphql';
import { fastTransformer, toHidden, toTree } from '../utils/form';
import { Brand, Company, FoodService, Retailer } from '../server-types';
import { EntityCreateModal } from "../types/entities";


export const BrandCreate: React.FC<EntityCreateModal<Brand, Company | Retailer | FoodService>> = ({
	originalEntity,
	onSubmit,
}) => (
	<UserData>
		{({ isInternal }) => (
			<EntityEditFetcher
				create={true}
				modal={true}
				entityName={ENTITY.BRAND}
				fetcher={graphqlQuery(BrandCreateQuery)}
				mutation={BrandCreateMutation}
				onSubmit={onSubmit}
				typeIntro={typeIntro}
				inputTypeIntro={inputTypeIntro}
				entitiesToFields={(props) => ({
					EditorialSections: props.editorialSectionTree,
				})}
				fields={[
					'Company',
					'Retailer',
					'FoodService',
					'name',
					'logoMedia',
					'pricePositioning',
					'goodClasses',
					'retailChainDistribution',
					'foodServiceChainDistribution',
					'gourmetShopChainDistribution',
					isInternal ? 'order' : null,
					'website',
					'socialInstagramPage',
					'socialFacebookPage',
				]}
				transformer={(data, entity, listsByType) => {
					data.fields = fastTransformer({
						Retailer: (f) => {
							f.afterChange = (ff, value, fields) => {
								if (value !== null) {
									fields.filter((f) => ['Company', 'FoodService'].indexOf(f.name) > -1).map((f) => { f.disabled = true; });
								} else {
									fields.filter((f) => ['Company', 'FoodService'].indexOf(f.name) > -1).map((f) => { f.disabled = false; });
								}
								return fields;
							}
							if (originalEntity) {
								if (originalEntity.__typename === ENTITY.RETAILER) {
									return toHidden(toRefInput(originalEntity))(f);
								}
								return toHidden(f.value)(f);
							}
							return f;
						},
						FoodService: (f) => {
							f.afterChange = (ff, value, fields) => {
								if (value !== null) {
									fields.filter((f) => ['Company', 'Retailer'].indexOf(f.name) > -1).map((f) => { f.disabled = true; });
								} else {
									fields.filter((f) => ['Company', 'Retailer'].indexOf(f.name) > -1).map((f) => { f.disabled = false; });
								}
								return fields;
							}
							if (originalEntity) {
								if (originalEntity.__typename === ENTITY.FOOD_SERVICE) {
									return toHidden(toRefInput(originalEntity))(f);
								}
								return toHidden(f.value)(f);
							}
							return f;
						},
						Company: (f) => {
							f.afterChange = (ff, value, fields) => {
								if (value !== null) {
									fields.filter((f) => ['Retailer', 'FoodService'].indexOf(f.name) > -1).map((f) => { f.disabled = true; });
								} else {
									fields.filter((f) => ['Retailer', 'FoodService'].indexOf(f.name) > -1).map((f) => { f.disabled = false; });
								}
								return fields;
							}
							if (originalEntity) {
								if (originalEntity.__typename === ENTITY.COMPANY) {
									return toHidden(toRefInput(originalEntity))(f);
								}
								return toHidden(f.value)(f);
							}
							return f;
						},
						goodClasses: (f) => {
							if (f.type === 'AsyncChoices') {
								if (isInternal) {
									return toTree(
										f,
										false,
										editorialSectionsToTree(
											listsByType.EditorialSections,
										),
									);
								} else {
									return toHidden(f.value)(f);
								}
							}
							return f;
						},
					})(data.fields);
					return data;
				}}
			/>
		)}
	</UserData>
);
